// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './firebase/config'; // Import Firebase config to ensure it initializes

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 // <React.StrictMode>
    <App />
 // </React.StrictMode>
);